"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var BrandedServiceLink_1 = __importDefault(require("shared/hds/BrandedServiceLink"));
var RenewalUpcoming = function (_a) {
    var _b = __read(_a.notifications, 1), notif = _b[0];
    if (!notif.service || !notif.serviceStat)
        return null;
    var sSWithDaysLeft = (0, end2end_1.addRenewalDaysAway)(notif.serviceStat);
    if (sSWithDaysLeft.renewalDaysAway && sSWithDaysLeft.renewalDaysAway < 0)
        return null;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Upcoming renewal for ", (0, jsx_runtime_1.jsx)(BrandedServiceLink_1.default, { service: notif === null || notif === void 0 ? void 0 : notif.service }), " in ", sSWithDaysLeft.renewalDaysAway, ' ', "day", sSWithDaysLeft.renewalDaysAway !== 1 && 's'] }));
};
exports.default = RenewalUpcoming;
